export const translations = {
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      process: 'Process',
      contact: 'Contact',
      contactUs: 'Contact Us'
    },
    hero: {
      title: 'Your Trusted Partner for Global Sourcing',
      subtitle: 'We connect European and African businesses with reliable global suppliers — making importing accessible, safe, and profitable.',
      tagline: 'Strong Relationships. Better Business.',
      emailUs: 'Email Us',
      whatsappUs: 'WhatsApp Us'
    },
    aboutUs: {
      title: 'About Us',
      text: 'NexumTrades was born from a conviction: the best businesses are built on trust. In a world where importing can seem simple — a search online, a contact, an order — the reality of supplier markets is very different. Knowing a supplier is not the same as trusting them. And trusting without verifying is where expensive mistakes happen.',
      text2: 'We bring years of real experience in procurement and international product development. We know the markets, their dynamics and their pitfalls. We accompany every project from end to end — from supplier identification to final delivery — with rigor, transparency and proximity.',
      text3: 'Nexum, in Latin, means bond. It\'s what we are. It\'s what we build with every client.',
      tagline: 'Strong Relationships. Better Business.'
    },
    about: {
      title: 'Who We Are',
      missionTitle: 'Our Mission',
      missionText: 'To develop and deliver the best products through rigorous sourcing, validation and quality control. Our focus is product excellence — and the trust of those who choose us as partners.',
      visionTitle: 'Our Vision',
      visionText: 'To be the European reference in sourcing and procurement, raising industry standards through solid partnerships built on real relationships and consistent results.',
      valuesTitle: 'Our Values',
      integrityTitle: 'Integrity',
      integrityDesc: 'We act with honesty in every partnership and transaction. No shortcuts, no surprises.',
      responsibilityTitle: 'Responsibility',
      responsibilityDesc: 'We treat every project as our own. Rigorous validation, quality control and sustainable sourcing practices are non-negotiable.',
      partnershipTitle: 'Partnership',
      partnershipDesc: 'We believe the best business comes from strong relationships. We build collaborations based on mutual trust and shared success.'
    },
    values: {
      subtitle: 'How we act defines what we deliver'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Each service is designed to protect your interests — from the first supplier contact to final delivery.',
      service1Title: 'Supplier Identification & Selection',
      service1Desc: 'Finding the right supplier is the first step — and the most critical. We conduct an in-depth analysis of the supplier market, evaluating credibility, production capacity and export history.',
      service2Title: 'Commercial Negotiation',
      service2Desc: 'Good negotiation is not just about getting the lowest price. It\'s finding the right balance between price, quality, volumes and delivery times.',
      service3Title: 'Sample Management & Technical Validation',
      service3Desc: 'The sample is the real contract. We manage the entire sampling process — request, receipt, technical analysis and approval — ensuring the final product matches what was agreed.',
      service4Title: 'Production Follow-up & Quality Control',
      service4Desc: 'Confirmed production is not guaranteed production. We follow the process on the ground, with continuous monitoring and quality inspections.',
      service5Title: 'End-to-End Logistics & Compliance',
      service5Desc: 'From the factory to your door. We manage the entire logistics operation — documentation, shipment, customs and final delivery — with compliance monitoring at every stage.'
    },
    benefits: {
      title: 'What You Gain with Our Service',
      subtitle: 'The tangible benefits of partnering with NexumTrades',
      benefit1Title: 'Reduced Costs & Risks',
      benefit1Desc: 'Minimized operational risks and optimized costs through expert procurement management.',
      benefit2Title: 'Secure & Transparent',
      benefit2Desc: 'Safe, transparent processes with clear communication throughout the sourcing journey.',
      benefit3Title: 'Validated Suppliers',
      benefit3Desc: 'Thoroughly validated suppliers and products aligned with your specific business needs.',
      benefit4Title: 'Full-Cycle Management',
      benefit4Desc: 'Experienced team managing the complete procurement cycle, allowing you to focus on growth.'
    },
    process: {
      title: 'How We Work',
      subtitle: 'A clear, transparent process from initial consultation to final delivery',
      step1Title: 'Understand Needs',
      step1Desc: 'Deep dive into your sourcing requirements and business objectives',
      step2Title: 'Validate Suppliers',
      step2Desc: 'Rigorous on-ground validation of supplier capabilities and credibility',
      step3Title: 'Develop & Approve',
      step3Desc: 'Product development, sample validation, and technical approval',
      step4Title: 'Control Quality',
      step4Desc: 'Continuous production monitoring and quality control',
      step5Title: 'Deliver with Confidence',
      step5Desc: 'Logistics coordination and final delivery to your specifications'
    },
    cta: {
      title: 'Ready to Import with Confidence?',
      subtitle: 'If you are looking for a trusted partner to ensure safe, efficient and cost-effective sourcing, we are ready to support your business.'
    },
    footer: {
      description: 'Your trusted partner for global sourcing and procurement.',
      contact: 'Contact',
      quickLinks: 'Quick Links',
      aboutUs: 'About Us',
      howWeWork: 'How We Work',
      rights: 'All rights reserved.',
      website: 'www.nexumtrades.com'
    }
  },
  pt: {
    nav: {
      about: 'Sobre',
      services: 'Serviços',
      process: 'Processo',
      contact: 'Contacto',
      contactUs: 'Contacte-nos'
    },
    hero: {
      title: 'O Seu Parceiro de Confiança para Sourcing Global',
      subtitle: 'Conectamos empresas europeias e africanas com fornecedores globais fiáveis — tornando a importação acessível, segura e rentável.',
      tagline: 'Relações Fortes. Melhores Negócios.',
      emailUs: 'Enviar Email',
      whatsappUs: 'WhatsApp'
    },
    aboutUs: {
      title: 'Sobre Nós',
      text: 'A NexumTrades nasceu de uma convicção: os melhores negócios constroem-se sobre confiança. Num mundo onde importar pode parecer simples — uma pesquisa online, um contacto, uma encomenda — a realidade dos mercados de fornecedores é muito diferente. Conhecer um fornecedor não é o mesmo que confiar nele. E confiar sem verificar é onde os erros caros acontecem.',
      text2: 'Trazemos anos de experiência real em procurement e desenvolvimento de produtos internacionais. Conhecemos os mercados, as suas dinâmicas e as suas armadilhas. Acompanhamos cada projeto de ponta a ponta — desde a identificação do fornecedor até à entrega final — com rigor, transparência e proximidade.',
      text3: 'Nexum, em Latim, significa vínculo. É o que somos. É o que construímos com cada cliente.',
      tagline: 'Relações Fortes. Melhores Negócios.'
    },
    about: {
      title: 'Quem Somos',
      missionTitle: 'A Nossa Missão',
      missionText: 'Desenvolver e entregar os melhores produtos através de sourcing rigoroso, validação e controlo de qualidade. O nosso foco é a excelência do produto — e a confiança de quem nos escolhe como parceiros.',
      visionTitle: 'A Nossa Visão',
      visionText: 'Ser a referência europeia em sourcing e procurement, elevando os padrões da indústria através de parcerias sólidas construídas sobre relações reais e resultados consistentes.',
      valuesTitle: 'Os Nossos Valores',
      integrityTitle: 'Integridade',
      integrityDesc: 'Agimos com honestidade em cada parceria e transação. Sem atalhos, sem surpresas.',
      responsibilityTitle: 'Responsabilidade',
      responsibilityDesc: 'Tratamos cada projeto como nosso. Validação rigorosa, controlo de qualidade e práticas de sourcing sustentáveis são inegociáveis.',
      partnershipTitle: 'Parceria',
      partnershipDesc: 'Acreditamos que o melhor negócio vem de relações fortes. Construímos colaborações baseadas em confiança mútua e sucesso partilhado.'
    },
    values: {
      subtitle: 'Como agimos define o que entregamos'
    },
    services: {
      title: 'Os Nossos Serviços',
      subtitle: 'Cada serviço é concebido para proteger os seus interesses — desde o primeiro contacto com o fornecedor até à entrega final.',
      service1Title: 'Identificação e Seleção de Fornecedores',
      service1Desc: 'Encontrar o fornecedor certo é o primeiro passo — e o mais crítico. Realizamos uma análise aprofundada do mercado de fornecedores, avaliando credibilidade, capacidade de produção e histórico de exportação.',
      service2Title: 'Negociação Comercial',
      service2Desc: 'Uma boa negociação não é apenas conseguir o preço mais baixo. É encontrar o equilíbrio certo entre preço, qualidade, volumes e prazos de entrega.',
      service3Title: 'Gestão de Amostras e Validação Técnica',
      service3Desc: 'A amostra é o verdadeiro contrato. Gerimos todo o processo de amostragem — pedido, receção, análise técnica e aprovação — garantindo que o produto final corresponde ao acordado.',
      service4Title: 'Acompanhamento de Produção e Controlo de Qualidade',
      service4Desc: 'Produção confirmada não é produção garantida. Acompanhamos o processo no terreno, com monitorização contínua e inspeções de qualidade.',
      service5Title: 'Logística e Conformidade de Ponta a Ponta',
      service5Desc: 'Da fábrica à sua porta. Gerimos toda a operação logística — documentação, envio, alfândega e entrega final — com monitorização de conformidade em cada etapa.'
    },
    benefits: {
      title: 'O Que Ganha com o Nosso Serviço',
      subtitle: 'Os benefícios tangíveis de fazer parceria com a NexumTrades',
      benefit1Title: 'Custos e Riscos Reduzidos',
      benefit1Desc: 'Riscos operacionais minimizados e custos otimizados através de gestão especializada de procurement.',
      benefit2Title: 'Seguro e Transparente',
      benefit2Desc: 'Processos seguros e transparentes com comunicação clara ao longo de toda a jornada de sourcing.',
      benefit3Title: 'Fornecedores Validados',
      benefit3Desc: 'Fornecedores e produtos minuciosamente validados e alinhados com as suas necessidades empresariais específicas.',
      benefit4Title: 'Gestão de Ciclo Completo',
      benefit4Desc: 'Equipa experiente a gerir o ciclo completo de procurement, permitindo-lhe focar no crescimento.'
    },
    process: {
      title: 'Como Trabalhamos',
      subtitle: 'Um processo claro e transparente desde a consulta inicial até à entrega final',
      step1Title: 'Compreender Necessidades',
      step1Desc: 'Análise profunda dos seus requisitos de sourcing e objetivos de negócio',
      step2Title: 'Validar Fornecedores',
      step2Desc: 'Validação rigorosa no terreno das capacidades e credibilidade dos fornecedores',
      step3Title: 'Desenvolver e Aprovar',
      step3Desc: 'Desenvolvimento de produto, validação de amostras e aprovação técnica',
      step4Title: 'Controlar Qualidade',
      step4Desc: 'Monitorização contínua da produção e controlo de qualidade',
      step5Title: 'Entregar com Confiança',
      step5Desc: 'Coordenação logística e entrega final de acordo com as suas especificações'
    },
    cta: {
      title: 'Pronto para Importar com Confiança?',
      subtitle: 'Se procura um parceiro de confiança para garantir um sourcing seguro, eficiente e rentável, estamos prontos para apoiar o seu negócio.'
    },
    footer: {
      description: 'O seu parceiro de confiança para sourcing e procurement global.',
      contact: 'Contacto',
      quickLinks: 'Links Rápidos',
      aboutUs: 'Sobre Nós',
      howWeWork: 'Como Trabalhamos',
      rights: 'Todos os direitos reservados.',
      website: 'www.nexumtrades.com'
    }
  }
};
